import InvoiceReducer from "./invoice";
import OfferingReducer from "./offering";
import PaymentReducer from "./payment";
import PurchaseOrderReducer from "./purchase-order";
import PurchaseRecapReducer from "./purchase-recap";
import PurchaseRequestReducer from "./purchase-request";
import PurchaseReturnReducer from "./purchase-return";
import QuotationRequestReducer from "./quotation";
import ReceivingReducer from "./receiving";

export default {
    invoice:InvoiceReducer,
    offering:OfferingReducer,
    payment:PaymentReducer,
    purchaseOrder:PurchaseOrderReducer,
    purchaserecap:PurchaseRecapReducer,
    purchaserequest:PurchaseRequestReducer,
    purchasereturn:PurchaseReturnReducer,
    quotationRequest:QuotationRequestReducer,
    receiving:ReceivingReducer,
}
    
   